/**
 * Maps a raw session type coming from the API (e.g. "NEW", "PRACTICE") to the
 * canonical challenge type consumed by `ChallengeTypeTag`.
 *
 * This is the single source of truth for the mapping so the practice view and
 * the student recommendations always render the same tag for the same session.
 */
export function mapSessionTypeToChallenge(sessionType?: string): string {
  const typeMap: Record<string, string> = {
    NEW: 'new',
    PRACTICE: 'review',
  };

  if (!sessionType) return 'new';

  return typeMap[sessionType] || 'new';
}
